import { render, staticRenderFns } from "./JobAlert.vue?vue&type=template&id=499ba61f&scoped=true"
import script from "./JobAlert.vue?vue&type=script&lang=js"
export * from "./JobAlert.vue?vue&type=script&lang=js"
import style0 from "./JobAlert.vue?vue&type=style&index=0&id=499ba61f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ba61f",
  null
  
)

export default component.exports